/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import Images from 'assets/img';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import TruckerActions from 'store/ducks/trucker';
import { Row } from 'styles/components';
import api from 'services/api';

import { Container, WrapperTable, EyeIcon, Icon, EditIcon, DeleteIcon } from './styles';

function Trucker() {
  const dispatch = useDispatch();
  const { truckers, isLoading } = useSelector((state) => state.trucker);
  const history = useHistory();
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(TruckerActions.getTruckersRequest());
  }, [dispatch]);

  if (isLoading) {
    return <LoadingPage />;
  }

  // Função auxiliar para formatar data com validação
  const formatDate = (dateValue) => {
    if (!dateValue) return '';
    try {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';
      return format(date, 'dd/MM/yyyy');
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return '';
    }
  };

  // Função auxiliar para converter data para timestamp (compatível com Firebase e Supabase)
  const getTimestamp = (dateValue) => {
    if (!dateValue) return null;
    try {
      // Se for objeto Firebase Timestamp (com .seconds)
      if (dateValue.seconds) {
        return dateValue.seconds * 1000;
      }
      // Se for string ISO ou Date
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return null;
      return date.getTime();
    } catch (error) {
      console.error('Erro ao converter data:', error);
      return null;
    }
  };

  // Função auxiliar para formatar hora
  const formatTime = (dateValue) => {
    if (!dateValue) return '';
    try {
      const timestamp = getTimestamp(dateValue);
      if (!timestamp) return '';
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return '';
      return date.toString().substring(16, 24);
    } catch (error) {
      console.error('Erro ao formatar hora:', error);
      return '';
    }
  };

  const data = truckers.map((item) => ({
    ...item,
    actions: item.id,
    id: item.id,
    name: item.name,
    phone: item.phone,
    email: item.email,
    cpf: item.cpf || '-',
    date: getTimestamp(item.created_at) || new Date().getTime(),
    time: formatTime(item.created_at),
    updated: item?.status === 1 ? getTimestamp(item.updated_at) : null,
    updated_time: item?.status === 1 ? formatTime(item.updated_at) : '',
  }));

  const filteredData = data.filter(
    (item) =>
      (item.name || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.email || '').toUpperCase().includes(search.toUpperCase())
  );

  const handleOpenModalTrucker = (trucker = null) => {
    if (trucker) {
      history.push(`/trucker/edit/${trucker.id}`);
    } else {
      history.push('/trucker/new');
    }
  };

  const handleDeleteTrucker = (id) => {
    if (window.confirm('Tem certeza que deseja excluir este caminhoneiro?')) {
      dispatch(TruckerActions.removeTruckerRequest(id));
    }
  };

  return (
    <Container>
      <Paper
        title="Caminhoneiros"
        icon={Images.IconGrayUsers}
        rightContent={
          <Row>
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              value={search}
            />
            <button
              onClick={() => handleOpenModalTrucker()}
              style={{
                marginLeft: '10px',
                padding: '8px 16px',
                backgroundColor: '#122D58',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Novo Caminhoneiro
            </button>
          </Row>
        }
      >
        <WrapperTable>
          <Table
            columns={[
              { label: 'Ações', id: 'actions' },
              { label: 'ID', id: 'id' },
              { label: 'Nome', id: 'name' },
              { label: 'Telefone', id: 'phone' },
              { label: 'E-mail', id: 'email' },
              { label: 'CPF', id: 'cpf' },
              { label: 'Data de cadastro', id: 'date' },
              { label: 'Hora de cadastro', id: 'time' },
              { label: 'Data Liberação', id: 'updated' },
              { label: 'Hora Liberação', id: 'updated_time' },
              { label: 'Status', id: 'status' },
            ]}
            activePage={0}
            totalPages={2}
            data={filteredData}
            customComponent={{
              actions: (e) => (
                <Row>
                  <EyeIcon
                    onClick={() => history.push('/trucker_data', { id: e })}
                    title="Ver detalhes"
                  />
                  <EditIcon
                    onClick={() => {
                      const trucker = truckers.find((t) => t.id === e);
                      if (trucker) {
                        handleOpenModalTrucker(trucker);
                      }
                    }}
                    title="Editar caminhoneiro"
                  />
                  <DeleteIcon
                    onClick={() => handleDeleteTrucker(e)}
                    title="Excluir caminhoneiro"
                  />
                </Row>
              ),
              date: (e) => formatDate(e),
              updated: (e) => formatDate(e),
              status: (e) =>
                e === 0 ? (
                  <Icon src={Images.Block} />
                ) : (
                  <Icon src={Images.Check} />
                ),
            }}
          />
        </WrapperTable>
      </Paper>
    </Container>
  );
}

export default Trucker;
